import React from "react";
import type { Training } from "../../../../api/training/Training.typed";

export type RefreshTrainingsFn = () => Promise<Training[]>;

export type TrainingsListRefreshContextValue = {
  getRefresh: () => RefreshTrainingsFn | null;
} | null;

export const TrainingsListRefreshContext =
  React.createContext<TrainingsListRefreshContextValue>(null);

export function useTrainingsListRefreshContext(): TrainingsListRefreshContextValue {
  return React.useContext(TrainingsListRefreshContext);
}
